import React from 'react';
import { Outlet } from 'react-router-dom';
import SubNavigator from '../../components/SubNavigator';
import { PageContainer, SideNavigation, SectionContainer, SectionHeading, MainContent } from '../../components/SubNavigator';

const sections = [
  {
    heading: '고객센터',
    links: [
      { path: '/CSCenter/Notices', label: '공지사항' },
      { path: '/CSCenter/Support', label: '구매문의' },
      { path: '/CSCenter/Inquiries', label: '1:1문의' },
    ],
  }
];


export default function Settings() {
  return (
    <PageContainer>
      <SideNavigation> {/* 네비게이션을 좌측으로 배치 */}
        {sections.map((section, index) => (
          <SectionContainer key={index}>
            <SectionHeading>{section.heading}</SectionHeading>
            <SubNavigator links={section.links} />
          </SectionContainer>
        ))}
      </SideNavigation>
      <MainContent> {/* 메인 컨텐츠는 나머지 공간을 차지 */}
        <Outlet />
      </MainContent>
    </PageContainer>
  );
}